import { computed, context } from '@vue/composition-api'
import * as _ from 'lodash'

export const ContractNote = (context) => {
  // contextからstore取り出し
  const store = context.root.$store
  const { contract } = store.state

  store.dispatch('contract/getContractData')
  store.dispatch('users/getUsersData')

  const sortedUsers = computed(() => {
    return store.getters['users/sortedNoteNum']
  })

  const columNumber = 3
  // 高さ揃え
  const titleHeight = computed(() => {
    return (index) => {
      context.root.$nextTick(() => {
        const remainder = index % columNumber
        const rowNumber = index - remainder
        const ref = context.refs['boxTitle' + index]
        const heights = []
        _.forEach(Array(columNumber), (value, key) => {
          // v-for内でrefを作成しているため、refは配列
          context.refs['boxTitle' + (rowNumber + key)] &&
            context.refs['boxTitle' + (rowNumber + key)][0] &&
            heights.push(context.refs['boxTitle' + (rowNumber + key)][0].clientHeight)
        })
        context.refs['boxTitle' + index][0].style.height = _.max(heights) + 'px'
      })
    }
  })

  const noteIsMax = computed(() => {
    return contract.note_number >= contract.note_number_max
  })

  const close = () => {
    context.emit('closeNoteBreakdown')
  }
  const submit = () => {
    // todo submit
    context.emit('closeNoteBreakdown')
  }

  return {
    contract,
    noteIsMax,
    titleHeight,
    sortedUsers,
    close,
    submit
  }
}
